import { isPhysicalProduct } from '@strix/checkout/helpers/productsType'
import types from './types'

export const mutations = {
  [types.IS_SAME_AS_SHIPPING_SENT] (state, shippingAddresses) {
    state.isSameAsShippingSent = shippingAddresses.length <= 1
  },

  [types.SET_SHIPPING_FOR_ITEMS] (state, payload) {
    const { isPaczkomatSelected, items } = payload
    const physicalItems = items.filter(({ _typename }) => isPhysicalProduct(_typename)) || []

    const isOnlyPaczkomat = physicalItems.every(item =>
      item.estimatedShippingMethods.length === 1 &&
      item.estimatedShippingMethods[0].carrierCode === 'inpostpoints',
    )

    physicalItems.forEach((item) => {
      const currentSelectedShipping = state.shipping.find(o => o.id === item.id)
      const paczkomat = item.estimatedShippingMethods.filter(el => el?.carrierCode === 'inpostpoints')
      let cheapestCourier

      if (isOnlyPaczkomat) {
        cheapestCourier = item.estimatedShippingMethods[0]
      } else {
        cheapestCourier = item.estimatedShippingMethods
          .filter(el => el?.carrierCode !== 'inpostpoints')
          .reduce((prev, curr) => parseInt(prev?.priceFrom?.value) < parseInt(curr?.priceFrom?.value) ? prev : curr, null)
      }

      const selectedShippingCourier = isPaczkomatSelected ? paczkomat[0] : cheapestCourier

      if (!currentSelectedShipping) {
        state.shipping.push({
          id: item.id,
          selectedShippingCourier,
        })
      } else {
        currentSelectedShipping.selectedShippingCourier = selectedShippingCourier
      }
    })
  },

  [types.SET_SHIPPING_ADDRESS_FOR_ITEMS] (state, payload) {
    const {
      firstname,
      lastname,
      addressApartmentNumber = null,
      addressCity,
      addressHouseNumber,
      addressPostcode,
      addressStreet,
      phone,
    } = payload

    state.shipping = state.shipping?.map((item) => {
      return {
        ...item,
        selectedShippingAddress: {
          firstname,
          lastname,
          addressApartmentNumber,
          addressCity,
          addressHouseNumber,
          addressPostcode,
          addressStreet,
          phone,
        },
      }
    })
  },

  [types.UPDATE_SHIPPING] (state, items) {
    const ids = items.map(o => o.id)

    state.shipping = state.shipping.filter(({ id }) => ids.includes(id))
  },

  [types.SET_SHIPPING_PRICE] (state, { cart: { shippingAddresses } }) {
    state.finalShippingPrice = shippingAddresses?.reduce((acc, item) => {
      const { value, currency } = item.selectedShippingMethod?.amount || {
        value: 0,
        currency: '',
      }

      return {
        value: Number((acc.value || 0) + value),
        currency: currency || (acc.currency || ''),
      }
    }, {})
  },

  [types.SET_SHIPPING_TYPE] (state, payload) {
    state.type = payload
  },

  [types.SET_POINT] (state, payload) {
    state.paczkomat = payload
  },

  [types.SET_POINT_DETAIL] (state, payload) {
    state.paczkomatDetail = payload
  },
}
